import React from 'react';
import RequiredIcon from '../../../../SVG/RequiredIcon';
import {Tooltip} from 'react-tooltip';
import {useTranslation} from '../../../../hooks/useTranslation';

const RequiredButton = ({handleRequired, item, idx, id, required}) => {
  const {t} = useTranslation();
  
  return (
    <div
      className='f-build__fd_trash'
      onClick={handleRequired}
      data-tooltip-id={`${id}-required-${idx}`}
      data-tooltip-content={t('createNewForm.components.requiredField')}
    >
      <RequiredIcon color={required ? '#DA6767' : '#999999'} />
      <Tooltip id={`${id}-required-${idx}`} place={'bottom-end'} />
    </div>
  );
};

export default RequiredButton;
